import { MdForwardToInbox } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaSquareFacebook } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { useSelector } from "react-redux";
import { FaTwitter } from "react-icons/fa";


const ContactUs = () => {
    const { profileData } = useSelector((state) => state.loginInfo);

    return (
        <div className=" d-flex justify-content-center p-3 p-sm-4 m-4 mt-0 m-sm-0" style={{ background: 'white', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
            <div className="row ">
                <div className="d-flex justify-content-between align-items-center mb-3">
                </div>
                <h4 className=" mb-3 text-center">Get in Touch</h4>
                <p className="text-center inquiries-text">
                    If you have any inquiries, get in touch with us. <br />
                    We’ll be happy to help you.
                </p>

                {/* Contact Details */}
                <div className="contact-details my-4">
                    <div className="d-flex align-items-center mb-3 justify-content-center">
                        <a href="mailto:">
                            <MdForwardToInbox className="fs-2 inbox-icon" />
                            <span className="inbox-mail" >{profileData.baseProfile.email}</span></a>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <a href="tel:7766554432 ">
                            <FaPhoneAlt className="fs-3 contact-icon" />
                            <span className="profile-contact-number">{profileData?.baseProfile?.mobileNumber}</span></a>
                    </div>
                </div>

                {/* Social Media */}
                <div className="social-media mt-4 text-center">
                    <h5 className="fw-bold">Social Media</h5>
                    <div className="d-flex flex-column align-items-start justify-content-center mt-3">
                        <div className="d-flex align-items-center mb-3 justify-content-center w-100">
                            <div className="text-left">
                                <FaSquareFacebook className="contact-us-social-icon facebook-color me-2" />
                                <span className="contact-us-social-text">Stay updated, connect, and engage with us on Facebook.</span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center mb-3 justify-content-center w-100">
                            <div className="text-left m-0 m-sm-2" >
                                <FaInstagram className="contact-us-social-icon insta-color" />
                                <span className="contact-us-social-text">Explore our visual world and discover beauty of our brand.</span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center w-100" style={{ marginLeft: '-10px' }}>
                            <div className="text-left">

                                <FaTwitter className="contact-us-social-icon twitter-color" />
                                <span className="contact-us-social-text" >
                                    Follow us for real-time updates and lively discussions.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
